import { default as AntDatePicker } from "antd/lib/date-picker";

import React from "react";

export function Input() {
  return React.useMemo(
    () => (
      <AntDatePicker.RangePicker
        placeholder={["Start", "Stop"]}
        allowEmpty={[false, true]}
      />
    ),
    []
  );
}

export namespace Input {}
